/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import {SalesVoModel} from './sales-vo.model';
import {EmployeeAutocompleteVoModel} from '@well/employee-autocomplete';

export class SalesDtoModel extends JSONable {
  uuid: string | undefined = undefined;
  pid: string | undefined = undefined;
  employee: EmployeeAutocompleteVoModel | undefined = undefined;
  salesManager: SalesVoModel | undefined = undefined;
  validFrom: Date | undefined = undefined;
  validTo: Date | undefined = undefined;
  salesChannelValue: string | undefined = undefined;
}
